export class ZoneType {
    public ZoneTypeId!: number;
    public ZoneTypeType!: string;
    public ZoneTypeName!: string;
}
